module.exports = __webpack_public_path__ + "static/media/santhanaraj.f0c9755d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/santhanaraj.jpg
// module id = 230
// module chunks = 0